import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash/omit';
import {useTranslation} from 'react-i18next';

import AlertSnackbar from './alert-snackbar.jsx';
import MiniDialog from './mini-dialog.jsx';

export const NOTIFICATION_TYPES = {
  snackbar: 'snackbar',
  miniDialog: 'miniDialog',
};

export const Notification = ({
  toastProps,
  title = '',
  message,
  type = NOTIFICATION_TYPES.snackbar,
  ...props
}) => {
  const {t} = useTranslation();
  const isMiniDialog = type === NOTIFICATION_TYPES.miniDialog;

  // keep the notification call backwards compatible
  const actions = props.action ? [props.action] : props.actions || null;
  // but map the actions to an array
  const actionButtons =
    actions &&
    actions.map(({label, onClick, ...action}, idx) => (
      <Button
        key={action.key || 'cta'}
        color={isMiniDialog ? 'primary' : 'grey'}
        variant={idx === actions.length - 1 ? 'contained' : 'text'}
        size={isMiniDialog ? 'medium' : 'small'}
        onClick={evt => {
          if (onClick) {
            onClick(evt);
            toastProps.closeToast();
          }
        }}
        {...action}
      >
        {label}
      </Button>
    ));

  const localizedTitle = !title?.i18nKey
    ? title
    : t(title.i18nKey, omit(title, 'i18nKey'));
  const localizedMessage = !message?.i18nKey
    ? message
    : t(message.i18nKey, omit(message, 'i18nKey'));

  const notificationProps = {
    ...props,
    title: localizedTitle,
    message: localizedMessage,
    actions: actionButtons,
  };

  return isMiniDialog ? (
    <MiniDialog {...notificationProps} />
  ) : (
    <AlertSnackbar {...notificationProps} />
  );
};

Notification.propTypes = {
  action: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  actions: PropTypes.array,
  message: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  toastProps: PropTypes.object,
};

export default Notification;
